import "./creditSubsequentsTranchesChangeData.css";
import React from "react";

const CreditSubsequentsTranchesChangeData = (props) => {
  const subsequentsTranchesChangeData =
    props.creditSubsequentsTranchesChanges.map(
      (creditSubsequentsTranchesChange) => (
        <>
          <tr key={creditSubsequentsTranchesChange.key}>
            <td>{creditSubsequentsTranchesChange.date}</td>
            <td>{creditSubsequentsTranchesChange.value}</td>
            <td>{creditSubsequentsTranchesChange.currency}</td>
            <td>
              <button
                className="actionButtonTable"
                value={creditSubsequentsTranchesChange.key}
                onClick={props.handleDeleteCreditSubsequentsTranchesChange}
              >
                Usuń
              </button>
            </td>
          </tr>
        </>
      )
    );

  const subsequentsTranchesChangeDataStructure = (
    <table className="subsequentsTranchesChangeTable">
      <tbody>
        <tr>
          <th>Data</th>
          <th>Wartość</th>
          <th>Waluta</th>
          <th>Akcja</th>
        </tr>
        {subsequentsTranchesChangeData}
      </tbody>
    </table>
  );

  return (
    <>
      <div className="tableRow">
        {props.creditSubsequentsTranchesChanges.length === 0
          ? ""
          : subsequentsTranchesChangeDataStructure}
      </div>
    </>
  );
};

export default CreditSubsequentsTranchesChangeData;
